export default __webpack_public_path__ + "static/media/scheduledIcon.db6f56c4.svg";